import React, { useState, useEffect, FC } from 'react';
import { Calendar } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useDispatch } from 'react-redux';

import { get } from '../../core/client';
import { getLocalStorageItem } from '../../core/utility';
import { IReactCalender } from '../../models/components/react-calendar';
import { useAppSelector } from '../../store';
import { setFilter } from '../../store/features/moments/momentsSlice';

const ReactCalendar: FC<IReactCalender> = ({ id, events, startDate, handleChangeValue, handleMonthChange, prevLabel, nextLabel, value }) => {
    const [state, setState] = useState({ tooltipOpen: false, target: null, currentDate: null });
    const [eventsDetails, setEventsDetails] = useState([]);
    const { filter, tuttorialIndex } = useAppSelector(state => state.moments);
    const { words } = useAppSelector(state => state.localization);
    const dispatch = useDispatch();
    const language = getLocalStorageItem('SelectedLanguage');

    const getTooltipContent = async () => {
        const month = state.currentDate.getMonth() + 1;
        const day = state.currentDate.getDate();
        const year = state.currentDate.getFullYear();
        const date = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);

        const eventsData = await get<any>(`user-specialdate-main/get-summary-detail-list?Date=${date}`);

        setEventsDetails(eventsData.result.items);
    };

    useEffect(() => {
        if (state.tooltipOpen && state.target) {
            if (id === 'calender-02' || id === 'calender-03') {
                const calenderContainer = document.getElementById('calender-container');
                if (window.innerHeight < 1000) {
                    if (id === 'calender-02') {
                        calenderContainer.scrollTop = 350;
                    } else if (id === 'calender-03') {
                        calenderContainer.scrollTop = calenderContainer.scrollHeight;
                    }
                } else {
                    if (id === 'calender-02') {
                        calenderContainer.scrollTop = 150;
                    } else if (id === 'calender-03') {
                        calenderContainer.scrollTop = calenderContainer.scrollHeight;
                    }
                }
            }

            const tooltip = document.getElementById(id);
            const targetBounds = state.target.getBoundingClientRect();
            tooltip.style.top = targetBounds.y + targetBounds.height + 'px';

            const calenderBounds = document.querySelector('.react-calendar__viewContainer').getBoundingClientRect();
            tooltip.style.left = calenderBounds.x + 'px';
        }

        if (state.currentDate) {
            setEventsDetails([]);
            getTooltipContent();
        }
    }, [state]);

    const handleDayClick = (value, event: React.MouseEvent<HTMLButtonElement>) => {
        if (event.currentTarget.classList.contains('active') && tuttorialIndex < 2) {
            setState({
                tooltipOpen: true,
                target: event.currentTarget,
                currentDate: value,
            });
            dispatch(
                setFilter({
                    ...filter,
                    specialDate: value,
                }),
            );
        } else {
            dispatch(
                setFilter({
                    ...filter,
                    specialDate: value,
                }),
            );
        }
    };

    const handleTooltipCloseClick = () => {
        setState({
            tooltipOpen: false,
            target: null,
            currentDate: null,
        });
    };

    const getClassNames = (date: Date) => {
        const result = events.filter(
            x =>
                new Date(x.date).getDate() === date.getDate() &&
                new Date(x.date).getMonth() === date.getMonth() &&
                new Date(x.date).getFullYear() === date.getFullYear(),
        );

        if (result.length > 0) {
            return (
                result
                    .map(x => x.color)
                    .sort()
                    .join('-') +
                ' ' +
                result.map(x => x.color).join(' ') +
                ' active'
            );
        }

        return '';
    };

    return (
        <>
            <Calendar
                onChange={e => (tuttorialIndex > 0 ? null : handleChangeValue(e, id))}
                onActiveStartDateChange={e => (tuttorialIndex > 0 ? null : handleMonthChange(e, id))}
                activeStartDate={startDate}
                value={value}
                prevLabel={tuttorialIndex > 0 ? null : prevLabel}
                nextLabel={tuttorialIndex > 0 ? null : nextLabel}
                prev2Label={null}
                next2Label={null}
                minDetail={'month'}
                showNeighboringMonth={false}
                tileClassName={({ activeStartDate, date, view }) => view === 'month' && events.length > 0 && getClassNames(date)}
                onClickDay={tuttorialIndex > 0 ? null : handleDayClick}
                locale={language.culture}
            />

            {state.tooltipOpen && (
                <div className="tooltip-moments">
                    <div className="tooltip-moments-overlay" onClick={handleTooltipCloseClick}></div>
                    <div className="tooltip-moments-box" id={id}>
                        {eventsDetails.length > 0 &&
                            eventsDetails.map((item, index) => (
                                <div className="c-item-001" key={'eventsDetails' + index}>
                                    <div className="c-item-001-A">
                                        <img src={item.imageURL} />
                                    </div>
                                    {item.showCount ? (
                                        <p className="c-item-001-B">
                                            {item.specialDateName} ({item.count} {words && words['WEB.person']})
                                        </p>
                                    ) : (
                                        <p className="c-item-001-B">{item.specialDateName}</p>
                                    )}
                                </div>
                            ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ReactCalendar;
